const updateList = (
  response,
  payload,
  dataList,
  setDataFunction,
  showErrorFunction,
  updateErrorList = false,
) => {
  let editedItem = JSON.parse(payload);
  if (response.ok || updateErrorList) {
    const itemIndex = (dataList ?? []).findIndex(
      (obj) => obj.id === editedItem.id,
    );
    // Not in this list — writing tmp[-1] would silently corrupt the array and
    // push a stale list back into state, so leave it alone.
    if (itemIndex >= 0) {
      const tmp = [...dataList];
      tmp[itemIndex] = editedItem;
      setDataFunction(tmp);
    }
  }

  if (
    !response.ok &&
    typeof showErrorFunction !== "undefined" &&
    showErrorFunction !== null
  ) {
    showErrorFunction(true);
  }
};

const deleteFromList = async (
  index,
  apiCall,
  setDataFunction,
  dataList,
  showErrorFunction,
) => {
  if (apiCall) {
    const response = await apiCall;
    if (response.ok) {
      dataList.splice(index, 1);
      let tmpList = [...dataList];
      setDataFunction(tmpList);
    } else {
      if (
        typeof showErrorFunction !== "undefined" &&
        showErrorFunction !== null
      ) {
        showErrorFunction(true);
      }
    }
  } else {
    dataList.splice(index, 1);
    let tmpList = [...dataList];
    setDataFunction(tmpList);
  }
};

// Add the new/create function instead of the endpoint
const newToList = (
  response,
  dataList,
  setDataFunction,
  showErrorFunction,
  addToFront = false,
) => {
  if (response.ok) {
    if (addToFront) {
      dataList.unshift(response.data);
    } else {
      dataList.push(response.data);
    }
    setDataFunction([...dataList]);
  } else {
    if (typeof showErrorFunction === "function") {
      showErrorFunction(true);
    }
  }
};

const replaceItemInList = (replaceItem, dataList, setDataFunction) => {
  const itemIndex = dataList.findIndex((obj) => obj.id === replaceItem.id);
  dataList.splice(itemIndex, 1, replaceItem);
  let tmpList = [...dataList];
  setDataFunction(tmpList);
};

const deleteWithoutCall = (deleteItem, dataList) => {
  const deleteId = Number(deleteItem?.share?.id ?? deleteItem?.id);

  // Guard: invalid id → do nothing
  if (!Number.isInteger(deleteId)) {
    console.error("deleteWithoutCall: invalid id", deleteItem);
    return dataList;
  }

  return (dataList ?? []).filter((obj) => obj.id !== deleteId);
};

const deleteWithoutCallAndId = (deleteItem, dataList) => {
  const itemIndex = dataList.indexOf(deleteItem);
  dataList.splice(itemIndex, 1);
  return dataList;
};

export default {
  updateList,
  newToList,
  deleteFromList,
  replaceItemInList,
  deleteWithoutCall,
  deleteWithoutCallAndId,
};
